module.exports = __webpack_public_path__ + "img/room-red.d3027fb3.png";